<template>
    <div class="cz-sider">
        <slot></slot> 
    </div>
</template>
<script>
export default {
    name: "cz-sider",
};
</script>
<style scoped>
</style>
